import { Routes, Route, Navigate } from "react-router-dom";
import Navigation from "../../components/Navigation/Navigation.js";
import Tournament from "./Tournament/index.js";
import Team from "./Team/Team.js";
import Overall from "./Overall/Overall.js";
import { useTranslation } from "react-i18next";
import Individual from "./Individual/Individual";

const MatchResults = () => {
  const { t } = useTranslation();
  const tabs = [
    {
      path: "individual_preliminaries",
      label: t("nav.preliminaries"),
    },
    { path: "individual_round16", label: t("nav.round-of-16") },
    { path: "individual_round8", label: t("nav.quarter-finals") },
    { path: "individual_round4", label: t("nav.semi-finals") },
    { path: "individual_round3", label: t("nav.third-place-match") },
    { path: "individual_round2", label: t("nav.finals") },
    { path: "tournament", label: t("nav.tournament") },
    { path: "team", label: t("nav.team") },
    { path: "overall", label: t("nav.overall") },
  ];

  return (
    <>
      <Navigation tabs={tabs} basePath="/match-results" variant="sub" />

      <Routes>
        <Route
          path="/"
          element={<Navigate to="individual_preliminaries" replace />}
        />
        <Route path="tournament/*" element={<Tournament />} />
        <Route path="team/*" element={<Team />} />
        <Route path="overall/*" element={<Overall />} />
        <Route path=":round/*" element={<Individual />} />
      </Routes>
    </>
  );
};
export default MatchResults;
